import React from 'react'
import styled from 'styled-components'
import { SCARLET_THEME } from '@constants/theme-prefs'

import AVATAR from '@graphics/scarlet.jpg'
const DISPLAY_NAME = 'ScRAWRlet xD'
const { mainColor, textColor } = SCARLET_THEME

const Container = styled.section`
  border: 1px solid black;
  padding: 0 15px;
`

const AvatarBio = styled.div`
  display: flex;
  margin-bottom: 15px;
`

const Avatar = styled.img`
  max-width: 160px;
  max-height: 160px;
  margin-right: 15px;
`

const Bio = styled.div``

const ContactsContainer = styled.div`
  border: 5px solid ${mainColor};

  & > header {
    background-color: ${mainColor};
    padding: 10px;
    font-size: 1.5rem;

    & > h1 {
      margin: 0;
      font-size: 1.5rem;
    }
  }
`

const ContactInfo = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 10px;
  display: grid;
  grid-template-columns: auto auto;
`

const ContactLink = styled.li`
  font-weight: bold;

  & > a {
    color: ${textColor};
    text-decoration: none;
  }
`

interface ContactOption {
  linkText: string
  icon?: string
}

const contactOptions: ContactOption[] = [
  { linkText: 'Add to Friends' },
  { linkText: 'Send Message' },
  { linkText: 'Instant Message' },
  { linkText: 'Add to Group' },
  { linkText: 'Add to Favorites' },
  { linkText: 'Forward to Friend' },
  { linkText: 'Block User' },
  { linkText: 'Report User' },
]

export default function AboutMe () {
  return (
    <Container>
      <header>
        <h1>{ DISPLAY_NAME }</h1>
      </header>
      <AvatarBio>
        <Avatar src={ AVATAR } alt={ `${DISPLAY_NAME}\'s profile picture` } />
        <Bio>
          <span>she/her
          <br />Mood: xDDD
          <br />Last active: 1 day ago</span>
        </Bio>
      </AvatarBio>
      <ContactsContainer>
        <header>
          <h1>Contact { DISPLAY_NAME }</h1>
        </header>
        <ContactInfo>
          { contactOptions.map((option, index) => <ContactLink key={ index }><a href="#">{ option.linkText }</a></ContactLink> )}
        </ContactInfo>
      </ContactsContainer>
    </Container>
  )
}